/**
 * Utility function to remove "bybit" (case insensitive) from messages
 * @param {string} message - The message to clean
 * @returns {string} - The cleaned message
 */
export const cleanBybitFromMessage = (message) => {
  if (!message || typeof message !== "string") return message;

  // Remove "bybit" case insensitive and trim any extra spaces
  return message.replace(/bybit/gi, "").replace(/\s+/g, " ").trim();
};
